// "How to play Tonk" — the rules exactly as the games function plays them
// (supabase/functions/games/tonk.ts). Shared by the on-screen guide and the
// VR rules panel.

/** Video walkthrough (wikiHow). Written rules: pagat.com/rummy/tonk.html. */
export const TONK_TUTORIAL_URL = 'https://www.youtube.com/watch?v=tjFyI8HoC0Y';
export const TONK_TUTORIAL_TITLE = 'How to Play Tonk — wikiHow';

export const TONK_RULES: { title: string; lines: string[] }[] = [
  {
    title: 'The deal',
    lines: [
      '2–4 players, one 52-card deck. Everyone gets 5 cards; the next card is turned up to start the discard pile and the rest is the stock.',
      'Card values: aces 1, number cards their number, J / Q / K 10. Your total is the value of the cards in your hand — low is good.',
      'The deal moves round the table each hand; the player left of the dealer goes first.',
    ],
  },
  {
    title: 'Tonk!',
    lines: [
      'If the 5 cards you are dealt add up to 49 or 50, that\'s a Tonk: you win the hand straight away and it pays double.',
      'If two players are dealt a Tonk, the hand is a push — nobody scores.',
    ],
  },
  {
    title: 'Your turn',
    lines: [
      '1. Draw one card: from the stock, or the top card of the discard pile. (Or drop instead — see below.)',
      '2. Lay down spreads and hit spreads, as many as you like (optional).',
      '3. Discard one card to end your turn. You can\'t throw back the discard you just picked up, unless it\'s your last card.',
      'Spread: 3 or 4 cards of the same rank, or 3 or more in a row of one suit (aces are low: A-2-3 is a run, Q-K-A is not).',
      'Hit: add one card to any spread on the table — yours or anyone else\'s.',
      'On screen: tap cards to select them, then Spread, Hit or Discard. In VR: poke or pinch the big buttons and cards.',
    ],
  },
  {
    title: 'Winning a hand',
    lines: [
      'Go out: get rid of every card (by spreading, hitting or your last discard) and you win the hand.',
      'Drop: at the start of your turn, before drawing, you can drop — everyone shows their hand. If your total is the lowest you win.',
      'Caught: if anyone ties or beats your total when you drop, you\'re caught — the lowest of them wins the hand (a tie goes to the first after you in turn order) and it pays double.',
      'Stock runs out: when the last stock card has been drawn and that turn ends, the lowest total wins (a tie goes to the tied player who would have played next).',
    ],
  },
  {
    title: 'Scoring',
    lines: [
      'The hand winner scores 1 point for every opponent — 2 points per opponent for a Tonk or a catch.',
      'Choose 3, 5, 7 or 10 hands in the lobby (default 5). Highest score at the end wins the game.',
      'Tied for the lead at the end? Play extra hands until someone leads (at most 5 more, then it\'s a draw between the leaders).',
    ],
  },
];
